import React from 'react';

import { type EmojiId } from '@app/client';
interface Props {
    sizeInPixels: number;
    emojiId: EmojiId;
    alt?: string;
}
export const EmojiImage = ({ sizeInPixels, emojiId, alt, ...rest }: Props) => {
    return (
        <img
            data-testid="emoji-image"
            alt={alt || ''}
            src={`data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="${sizeInPixels}px" height="${sizeInPixels}px" ><text y="1em" font-size="${sizeInPixels}">${emojiId}</text></svg>`}
            {...rest}
        />
    );
};
